import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer
} from '../template/FormulaFormTemplates';
import { PressureFlowInPipeVM } from './PressureFlowInPipeVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const PressureFlowInPipeComponent = (props) => {
  const vm = useRef(new PressureFlowInPipeVM(props)).current;
  useEffect(() => {
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer computeCallback={() => { vm.computePressureFlowInPipe() }} printCallback={() => { vm.launchAndExport() }} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults}>
          <span className="input-help-header">
            <a href={vm.helpLink} target='_blank'>Help select n value <img src={pdfLogo} alt={'PDF logo'} /> </a>
            <a href={vm.helpKeLink} target='_blank'>Help select Ke value <img src={pdfLogo} alt={'PDF logo'} /> </a>
          </span>
          <div className="">
            <h2 className="sections-heading">Specify</h2>
            <div className="">
              <RadioGroup
                labelId="pressure-flow-radio"
                items={[
                  {
                    id: "head",
                    name: "head",
                    label: "Head",
                    className: "usa-radio__input--tile",
                    checked: vm.headControl,
                    onChange: vm.handleFormChange,
                  },
                  {
                    id: "elevations",
                    name: "elevations",
                    label: "Elevations",
                    className: "usa-radio__input--tile",
                    checked: vm.elevationsControl,
                    onChange: vm.handleFormChange,
                  },
                ]}
              />
            </div>
          </div>
          <h2 className='sections-heading'>General</h2>
          {vm.specifyControl === 'Head' ?
            <Input
              label="Head on Pipe (ft)"
              idAndName="head-on-pipe"
              valid={!vm.formValidation.headOnPipe}
              value={vm.pressureFlowForm.headOnPipe}
              className={vm.PressureFlowErrorClass('headOnPipe')}
              type="number"
              step={'0.01'}
              onChange={(e) => { vm.handleFormChange(e) }}
              onBlur={(e) => vm.validateInput(e.target.name,e.target.value)}
              onKeyDown={vm.handleOnKeyDown}
              min={0.01}
            /> :
            <>
              <Input
                label="Water Surface Elevation (ft)"
                idAndName="water-surface-elev"
                valid={!vm.formValidation.waterSurfaceElev}
                value={vm.pressureFlowForm.waterSurfaceElev}
                className={vm.PressureFlowErrorClass('waterSurfaceElev')}
                type="number"
                step={'0.01'}
                onChange={(e) => { vm.handleFormChange(e) }}
                onBlur={(e) => vm.validateInput(e.target.name,e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                min={0.01}
              />
              <Input
                label="Invert Outlet Elevation (ft)"
                idAndName="invert-outlet-elev"
                valid={!vm.formValidation.invertOutletElev}
                value={vm.pressureFlowForm.invertOutletElev}
                className={vm.PressureFlowErrorClass('invertOutletElev')}
                type="number"
                step={'0.01'}
                onChange={(e) => { vm.handleFormChange(e) }}
                onBlur={(e) => vm.validateInput(e.target.name,e.target.value)}
                onKeyDown={vm.handleOnKeyDown}
                min={0}
              />
            </>
          }
          <Input
            label="Pipe Diameter (in)"
            idAndName="pipe-diameter"
            valid={!vm.formValidation.pipeDiameter}
            value={vm.pressureFlowForm.pipeDiameter}
            className={vm.PressureFlowErrorClass('pipeDiameter')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleFormChange(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            min={0.02}
          />
          <Input
            label="Pipe Length (ft)"
            idAndName="pipe-length"
            valid={!vm.formValidation.pipeLength}
            value={vm.pressureFlowForm.pipeLength}
            className={vm.PressureFlowErrorClass('pipeLength')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleFormChange(e) }}
            onBlur={(e) => vm.validateInput(e.target.name,e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
          />
          <Input
            label="Manning's n"
            idAndName="mannings-n"
            valid={!vm.formValidation.manningsN}
            value={vm.pressureFlowForm.manningsN}
            className={vm.PressureFlowErrorClass('manningsN')}
            type="number"
            step={0.0001}
            onChange={(e) => { vm.handleFormChange(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            min={0.0001}
          />
          <Input
            label="Entrance Loss Coefficient (Ke)"
            idAndName="entrance-loss-coeff"
            valid={!vm.formValidation.entranceLossCoeff}
            value={vm.pressureFlowForm.entranceLossCoeff}
            className={vm.PressureFlowErrorClass('entranceLossCoeff')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleFormChange(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
          />
          <Input
            label="Bend Loss Coefficient (Kb)"
            idAndName="bend-loss-coeff"
            valid={!vm.formValidation.bendLossCoeff}
            value={vm.pressureFlowForm.bendLossCoeff}
            className={vm.PressureFlowErrorClass('bendLossCoeff')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleFormChange(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
          />
        </InputContainer>
        <div className="col formula-information">
          {vm.hasResults ? (
            <div className="row formula-results">
              <ResultsContainer>
                <div className="col-auto result-value-group">
                  <div className="row">
                    <div className="col-auto result-label">Flow Q (cfs):</div>
                    <div className="col-auto result-value">{vm.pressureFlowResults.flowQ}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Velocity (ft/sec):</div>
                    <div className="col-auto result-value">{vm.pressureFlowResults.velocity}</div>
                  </div>
                  <div className="row">
                    <div className="col-auto result-label">Friction Coefficient (Kp):</div>
                    <div className="col-auto result-value">{vm.pressureFlowResults.fractionCoefficient}</div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-auto result-label long-value">Maximum Allowable Fall in Pipe (ft):</div>
                  </div>
                  <div className="row">
                    <div className="col-auto">{vm.pressureFlowResults.maxAllowableFall}</div>
                  </div>
                </div>
              </ResultsContainer>
            </div>
          ) : ''}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">

            <ImageContainer>
              <img
                className="pressure-flow-in-pipe-image"
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const PressureFlowInPipeFormula = observer(PressureFlowInPipeComponent);